import {
    useStripe,
    useElements,
    CardNumberElement,
    CardExpiryElement,
    CardCvcElement,
    PostalCodeElement,
  } from '@stripe/react-stripe-js';
  import { useEffect, useState } from 'react';
  import  { API_BASE_URL } from '../../services/config';
  import { store } from '../../store/store';
  import { useNavigate } from "react-router-dom";
  const ELEMENT_OPTIONS = {
    style: {
      base: {
        fontSize: '16px',
        lineHeight: '38px',
        color: '#FFFFFF',
        fontFamily: 'Inter, system-ui, sans-serif',
        '::placeholder': { color: '#9ca3af' },
      },
      invalid: {
        color: '#ef4444',
      },
    },
  };
  
  export default function CheckoutForm({customer, subscription, coupon}) {
    const stripe = useStripe();
    const elements = useElements();
    // console.log(customer)
    const [clientSecret, setClientSecret] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
	const navigate = useNavigate();
  
    // 1️⃣ Fetch SetupIntent on load
    useEffect(() => {
      fetch(API_BASE_URL+'stripe/create-setup-intent.json')
        .then(res => res.json())
        .then(data => {
            // console.log(data.data)
            setClientSecret(data.data.client_secret)
        });
    }, []);
  
    // 2️⃣ Submit handler
    const handleSubmit = async (e) => {
      e.preventDefault();
      setError('');
  
      if (!stripe || !elements || !clientSecret) return;
  
      setLoading(true);
      const USER_TOKEN = store.getState().authentication.user;
      const result = await stripe.confirmCardSetup(clientSecret, {
        payment_method: {
          card: elements.getElement(CardNumberElement),
          billing_details: {
            name: customer.dj_name,
            email: customer.email, // 'jr.jaime.diaz@gmail.com', //customer.email,
          },
        },
      });
  
      setLoading(false);
  
      if (result.error) {
        setError(result.error.message);
        return;
      }
  
      // ✅ pm_xxxxxxxxx
      const paymentMethodId = result.setupIntent.payment_method;
      console.log('PaymentMethod:', paymentMethodId);
  
      // 3️⃣ Send PM to backend
      const res = await fetch(API_BASE_URL+'stripe/create-subscription.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ payment_method: paymentMethodId, token: USER_TOKEN, subscription_id: subscription.id, coupon_code: coupon?.coupon_code ? coupon.coupon_code: '' }),
      });
	  const data = await res.json(); // <-- THIS is your API response

  	  console.log('response:', data);
	  if(data.data?.success){
		navigate(`/subscription/success/complete`);
	  } else {
		navigate(`/subscription/payment-failed`);
	  }
  
    //   alert('Card saved & subscription started!');
    };
  
    return (
      <form onSubmit={handleSubmit} style={{ maxWidth: 420 }}>
        {/* Card Number */}
        <div className="form-group card-payment">
          <label class="form-label">Card Number</label>
          <div className="input-box form-control">
            <CardNumberElement options={ELEMENT_OPTIONS} />
          </div>
        </div>
  
        {/* Expiry + CVC */}
        <div className="row">
          <div className="form-group  card-payment">
            <label class="form-label">Expiry</label>
            <div className="input-box form-control">
              <CardExpiryElement options={ELEMENT_OPTIONS} />
            </div>
          </div>
  
          <div className="form-group  card-payment">
            <label class="form-label">CVC</label>
            <div className="input-box form-control">
              <CardCvcElement options={ELEMENT_OPTIONS} />
            </div>
          </div>
        </div>
  
        {/* ZIP */}
        {/* <div className="form-group">
          <label class="form-label">ZIP Code</label>
          <div className="input-box">
            <PostalCodeElement options={ELEMENT_OPTIONS} />
          </div>
        </div> */}
  
        {error && <p className="error">{error}</p>}
  
        <button className="primary-btn card-payment" disabled={!stripe || loading}>
          {loading ? 'Processing...' : 'Subscribe'}
        </button>
      </form>
    );
  }
  